<template>
    <video
        :key="`block-type-video-static-${uid}`"
        :aria-description="props.modelValue.altText ?? ''"
        playsinline
        autoplay
        muted
        loop
    >
        <source
            :src="videoSrc"
            type="video/mp4"
        >
        <track kind="captions">
    </video>
</template>

<script lang="ts" setup>
    import type {
        ContentBlockRenderedVideo
    } from '~/types';
    import {
        useCdnResource
    } from 'x1-base/composables';

    const props = defineProps<{
        modelValue: ContentBlockRenderedVideo;
    }>();

    const {
        getResourceCdnUrl
    } = useCdnResource();

    const uid = useId();

    const videoSrc = computed(() => getResourceCdnUrl(props.modelValue.url));
</script>

<style lang="scss"></style>
